import { render, staticRenderFns } from "./ConsentRenewalShowPage.vue?vue&type=template&id=1d8a8b60&scoped=true&"
import script from "./ConsentRenewalShowPage.vue?vue&type=script&lang=ts&"
export * from "./ConsentRenewalShowPage.vue?vue&type=script&lang=ts&"
import style0 from "./ConsentRenewalShowPage.vue?vue&type=style&index=0&id=1d8a8b60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8a8b60",
  null
  
)

export default component.exports